export type ParsedTSV = {
  headers: string[];
  rows: Array<Record<string, string>>;
};

export function parseTSV(input: string, maxRows = 10_000): ParsedTSV {
  const records: string[][] = [];
  let record: string[] = [];
  let field = '';
  let quoted = false;

  for (let index = 0; index < input.length; index += 1) {
    const character = input[index];
    if (character === '"') {
      if (quoted && input[index + 1] === '"') {
        field += '"';
        index += 1;
      } else {
        quoted = !quoted;
      }
    } else if (character === '\t' && !quoted) {
      record.push(field);
      field = '';
    } else if ((character === '\n' || character === '\r') && !quoted) {
      if (character === '\r' && input[index + 1] === '\n') index += 1;
      record.push(field);
      if (record.some((value) => value.trim())) records.push(record);
      record = [];
      field = '';
    } else {
      field += character;
    }
  }

  if (quoted) throw new Error('닫히지 않은 따옴표가 있습니다. 원본 셀의 따옴표를 확인해 주세요.');
  record.push(field);
  if (record.some((value) => value.trim())) records.push(record);
  if (records.length < 2) throw new Error('헤더와 한 개 이상의 데이터 행을 붙여넣어 주세요.');

  const headers = records[0].map((value, index) => (index === 0 ? value.replace(/^\uFEFF/, '') : value).trim());
  if (headers.some((value) => !value)) throw new Error('비어 있는 열 이름이 있습니다.');
  const duplicate = headers.find((value, index) => headers.indexOf(value) !== index);
  if (duplicate) throw new Error(`중복된 열 이름이 있습니다: ${duplicate}`);

  const dataRecords = records.slice(1);
  if (dataRecords.length > maxRows) throw new Error(`한 번에 최대 ${maxRows.toLocaleString()}개 행까지 적용할 수 있습니다.`);
  const mismatchedIndex = dataRecords.findIndex((values) => values.length !== headers.length);
  if (mismatchedIndex >= 0) throw new Error(`${mismatchedIndex + 2}행의 열 개수가 헤더와 다릅니다.`);

  return {
    headers,
    rows: dataRecords.map((values) => Object.fromEntries(headers.map((header, index) => [header, values[index].trim()]))),
  };
}
